import apiClient from '@/services/axios'

export const leadsApi = {
  getLeads: (params) => apiClient.get('/Leads', { params }),
  updateLead: (leadId, data) => apiClient.put(`/Leads/${leadId}`, data),
  getLeadConfiguration: () => apiClient.get('/Leads/configuration'),
  updateLeadConfiguration: (data) => apiClient.put('/Leads/configuration', data)
} 